// Prix de revente conseille a un compte pro (GT-261007-HVGQ) : +45 % a +70 % sur son prix
// d'achat TTC — le prix qu'il paie, remise de son compte deduite. Meme regle partout :
// catalogue B2B, fiche produit, panier, paiement.
export const RESALE_MIN_MARKUP = 0.45;
export const RESALE_MAX_MARKUP = 0.7;

export const resaleRange = (purchase: number): [number, number] => [
  purchase * (1 + RESALE_MIN_MARKUP),
  purchase * (1 + RESALE_MAX_MARKUP),
];
